import { Config } from 'shared/lib/config';

const isProduction =
  Config.REACT_APP_NODE_ENV === 'staging' ||
  Config.REACT_APP_NODE_ENV === 'demo';

const Logger = {
  info: (...args) => {
    if (!isProduction) console.info('[INFO]:', ...args);
  },
  warn: (...args) => {
    console.warn('[WARN]:', ...args);
  },
  error: (...args) => {
    console.error('[ERROR]:', ...args);
  },
  table: (data) => {
    if (!isProduction) console.table(data);
  },
};

export default Logger;
